var React = require('react');

function ToolPhotoshop (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-foreground"},[React.createElement("path",{"d":"M14.1,9.7h-2.8H8.6V26h2.8v-5.9h2.8c0,0,4.6-0.6,4.6-5.4S14.1,9.7,14.1,9.7z M13.7,17.5h-2.3V12H14c0,0,2,0.3,2,2.9\n    S13.7,17.5,13.7,17.5z","key":0}),React.createElement("path",{"d":"M26.9,17v-2.6c0,0-1.4-0.8-3.1-0.9c-2.6-0.2-4.3,1.7-4.3,3.5s1.4,3.2,2.7,3.9c1.3,0.6,2.8,1.2,2.2,2.2\n    c-0.6,1-1.9,1-2.8,0.6c-1.1-0.5-2.1-0.9-2.1-0.9v2.8c0,0,1.2,0.8,3.6,0.8s4.4-1.6,4.4-3.7s-2-3.5-3.1-3.9c-1.1-0.5-2.1-1-1.6-2.4\n    C23.4,15,26.9,17,26.9,17z","key":1})]));
}

ToolPhotoshop.defaultProps = {"version":"1.0","width":"36px","height":"36px","viewBox":"0 0 36 36","xmlSpace":"preserve"};

module.exports = ToolPhotoshop;

ToolPhotoshop.default = ToolPhotoshop;
